<template>
  <div
    style="
      min-height: calc(100vh - 60px);
      background-color: rgb(43, 51, 91);
      flex: 1;
    "
  >
  <div style=" width: calc(100% - 20px); 
      padding-left:10px;padding-right:10px;  padding-top: 10px;padding-bottom: 10px;">
    <div style="width: 100%; display: flex; justify-content: space-between;;margin: 0 auto;
    ">
        <!-- <div class="two-row" style="justify-content: space-between;"> -->
          <div class="card">
            <h4 style="margin-top: 10px; color: #fff">会员信息统计</h4>
            <div style="width: 100%; height: 120px">
              <div
                style="
                  width: 100%;
                  height: 120px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    background-color: rgb(55, 72, 124);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    src="../assets/images/hy.png"
                    alt=""
                    style="width: 80%; height: 80%"
                  />
                </div>
                <div
                  style="
                    margin-left: 15px;
                    text-align: left;
                    color: #fff;
                    line-height: 25px;
                    height: 90upx;
                  "
                >
                  <p class="ptext">
                    会员总数：<span class="numtext2">{{
                      panelInfo.userTotal
                    }}</span>
                    人
                  </p>
                  <p class="ptext">
                    今日新增：<span class="numtext2">{{
                      panelInfo.todayRegister
                    }}</span>
                    人
                  </p>
                  <p class="ptext" v-if="panelInfo.totalXFQ < 10000">
                    流量池：<span class="numtext2">
                      {{ panelInfo.totalXFQ.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    流量池：
                    <span class="numtext2">{{ (panelInfo.totalXFQ / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p>

                  <p class="ptext" v-if="panelInfo.totalFlow < 10000">
                    共享池：<span class="numtext2">
                      {{ panelInfo.totalFlow.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    共享池：
                    <span class="numtext2">{{ (panelInfo.totalFlow / 10000).toFixed(2) }} </span>
                    <span class="sptext">万（</span>
                    <span class="sptext">总</span>
                    <span class="numtext2">{{(panelInfo.totalFlowHis / 10000).toFixed(2) }} </span>
                    <span class="sptext">万）</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card" >
            <h4 style="margin-top: 10px; color: #fff">资产汇总统计</h4>
            <div style="width: 100%; height: 120px">
              <div
                style="
                  width: 100%;
                  height: 120px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    background-color: rgb(55, 72, 124);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    src="../assets/images/hy.png"
                    alt=""
                    style="width: 80%; height: 80%"
                  />
                </div>
                <div
                  style="
                    margin-left: 15px;
                    text-align: left;
                    color: #fff;
                    line-height: 25px;
                    height: 90upx;
                  "
                >
                  <p class="ptext" v-if="panelInfo.totalDWQ < 10000">
                    DWQ：
                    <span class="numtext2">
                      {{ panelInfo.totalDWQ.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    DWQ：
                    <span class="numtext2" >
                      {{ (panelInfo.totalDWQ / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p>

                  <!-- <p class="ptext" v-if="panelInfo.totalXFQ < 10000">
                    消费券：<span class="numtext2">
                      {{ panelInfo.totalXFQ.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    消费券：
                    <span class="numtext2">{{ (panelInfo.totalXFQ / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p> -->
                  <p class="ptext" v-if="panelInfo.totalDHQ < 10000">
                    兑换券：<span class="numtext2">{{ panelInfo.totalDHQ.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    兑换券：<span class="numtext2">{{ (panelInfo.totalDHQ / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p>
                  <p class="ptext" v-if="panelInfo.totalXJQ < 10000">
                    现金券：<span class="numtext2">{{ panelInfo.totalXJQ.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    现金券：<span class="numtext2">{{ (panelInfo.totalXJQ / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p>
                  <p class="ptext" v-if="panelInfo.totalDIT < 10000">
                    DIT：<span class="numtext2">{{ panelInfo.totalDIT.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    DIT：<span class="numtext2">{{ (panelInfo.totalDIT / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card" style="width:25%">
            <h4 style="margin-top: 10px; color: #fff">OTC交易汇总统计</h4>
            <div
              style="
                width: 100%;
                height: 120px;
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <div
                style="
                  width: 100%;
                  height: 100px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    background-color: rgb(55, 72, 124);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    src="../assets/images/txhz.png"
                    alt=""
                    style="width: 80%; height: 80%"
                  />
                </div>
                <div
                  style="
                    margin-left: 10px;
                    text-align: left;
                    color: #fff;
                    line-height: 25px;
                    height: 90upx;
                  "
                >
                  <p class="ptext" v-if="panelInfo.otcSaleTotal < 10000">
                    挂卖总量：
                    <span class="numtext2" >
                      {{ panelInfo.otcSaleTotalCnt }}
                    </span>
                      <span class="sptext">笔</span> | 
                    <span class="numtext2" >
                      {{ panelInfo.otcSaleTotal  }}
                    </span>
                    <span class="sptext"> 元</span>
                  </p>
                  <p class="ptext" v-else>
                    挂卖总量：
                    <span class="numtext2" >
                      {{ panelInfo.otcSaleTotalCnt }}
                    </span>
                      <span class="sptext">笔</span> | 
                    <span class="numtext2" >
                      {{ (panelInfo.otcSaleTotal / 10000).toFixed(2) }}
                    </span>
                    <span class="sptext">万元</span>
                  </p>
                  <p class="ptext" v-if="panelInfo. todayOTCNum < 10000">
                    今日挂卖：
                    <span class="numtext2">
                      {{ panelInfo.todayOTCCnt }}
                    </span>
                      <span class="sptext">笔</span> | 
                    <span class="numtext2" >
                      {{ panelInfo. todayOTCNum }}
                    </span>
                    <span class="sptext"> 元</span>
                  </p>
                  <p class="ptext" v-else>
                    今日挂卖：<span class="numtext2">
                      {{ panelInfo.todayOTCCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext2" >
                      {{ (panelInfo. todayOTCNum / 10000).toFixed(2) }}</span
                    ><span class="sptext"> 万元</span>
                  </p>
                  <p class="ptext" v-if="panelInfo.otcSaleSuccessTotal < 10000">
                    挂卖中：<span class="numtext2">
                      {{ panelInfo.otcSaleSuccessTotalCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext2" >
                      {{ panelInfo.otcSaleSuccessTotal }}
                    </span>
                    <span class="sptext"> 元</span>
                  </p>
                  <p class="ptext" v-else>
                    挂卖中：<span class="numtext2">
                      {{ panelInfo.otcSaleSuccessTotalCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext2" >
                      {{ (panelInfo.otcSaleSuccessTotal / 10000).toFixed(2) }}</span
                    ><span class="sptext"> 万元</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card" style="width:25%">
            <h4 style="margin-top: 10px;color: #fff;">提现汇总统计</h4>
            <div
                style="width: 100%;height: 120px;display: flex;justify-content: space-around;align-items: center;">
              <div style="width: 100%;height: 100px;
						display: flex;justify-content: flex-start;align-items: center;">
                <div style="width: 80px;height: 80px;border-radius: 50px;background-color: rgb(55,72,124);
							display: flex;justify-content: center;align-items: center;">
                  <img src="../assets/images/sy.png" alt="" style="width: 80%;height: 80%;">
                </div>
                <div style="margin-left: 15px;text-align: left;color: #fff;line-height: 25px;height: 90upx;">
                  <p class="ptext" v-if="panelInfo.WithwardTotal < 10000">提现总量：<span class="numtext2" style="">{{panelInfo.WithwardTotalCnt}} <span class="sptext">笔</span> | {{panelInfo.WithwardTotal}} </span><span class="sptext"> 元</span></p>
									<p class="ptext" v-else>提现总量：<span class="numtext2" style="">{{panelInfo.WithwardTotalCnt}} <span class="sptext">笔</span> | {{(panelInfo.WithwardTotal/10000).toFixed(2)}}</span><span class="sptext"> 万元</span></p>
									<p class="ptext" v-if="panelInfo.todayWithward < 10000">今日提现：<span class="numtext" style="">{{panelInfo.todayWithwardCnt}} <span class="sptext">笔</span> | {{panelInfo.todayWithward}} </span><span class="sptext"> 元</span></p>
									<p class="ptext" v-else>今日提现：<span class="numtext" style="">{{panelInfo.todayWithwardCnt}} <span class="sptext">笔</span> | {{(panelInfo.todayWithward/10000).toFixed(2)}}</span><span class="sptext"> 万元</span></p>
									<p class="ptext" v-if="panelInfo.lastWithward < 10000">等待处理：<span class="numtext" style="">{{panelInfo.lastWithwardCnt}} <span class="sptext">笔</span> | {{panelInfo.lastWithward}} </span><span class="sptext"> 元</span></p>
									<p class="ptext" v-else>等待处理：<span class="numtext" style="">{{panelInfo.lastWithwardCnt}} <span class="sptext">笔</span> | {{(panelInfo.lastWithward/10000).toFixed(2)}}</span><span class="sptext"> 万元</span></p>
                </div>
              </div>
            </div>
          </div>
          
          
        <!-- </div> -->
    </div>
    <div style="width: 100%; display: flex; justify-content: space-between; margin-top:25px;">
      <div style="width: 80%">
        <!-- <div class="one-row">
          <div class="left-card">
            <h4 style="margin-top: 10px; color: #fff">会员信息统计</h4>
            <div
              style="
                width: 100%;
                height: 120px;
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <div
                style="
                  width: 40%;
                  height: 100px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    background-color: rgb(55, 72, 124);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    src="../assets/images/hy.png"
                    alt=""
                    style="width: 80%; height: 80%"
                  />
                </div>
                <div
                  style="
                    margin-left: 15px;
                    text-align: left;
                    color: #fff;
                    line-height: 25px;
                    height: 90upx;
                  "
                >
                  <p class="ptext">
                    会员总数：<span class="numtext2">{{
                      panelInfo.userTotal
                    }}</span>
                    人
                  </p>
                  <p class="ptext">
                    今日新增：<span class="numtext2">{{
                      panelInfo.todayRegister
                    }}</span>
                    人
                  </p>
                  <p class="ptext" v-if="panelInfo.totalXFQ < 10000">
                    流量池：<span class="numtext2">
                      {{ panelInfo.totalXFQ.toFixed(2) }} </span>
                    <span class="sptext"> 个</span>
                  </p>
                  <p class="ptext" v-else>
                    流量池：
                    <span class="numtext2">{{ (panelInfo.totalXFQ / 10000).toFixed(2) }} </span>
                    <span class="sptext"> 万个</span>
                  </p>
                </div>
              </div>
              <div
                style="
                  width: 60%;
                  border-left: 0.5px solid rgb(55, 72, 124);
                  height: 100px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    background-color: rgb(55, 72, 124);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 30px;
                  "
                >
                  <img
                    src="../assets/images/jp.png"
                    alt=""
                    style="width: 80%; height: 80%"
                  />
                </div>
                <div
                  style="
                    margin-left: 15px;
                    text-align: left;
                    color: #fff;
                    line-height: 25px;
                    height: 90upx;
                  "
                >
                  <p class="ptext">
                    预约抢购总单数：<span class="numtext2">{{
                      panelInfo.totalSubscribe
                    }}</span>
                    单
                  </p>
                  <p class="ptext">
                    今日 | 昨日：
                    <span class="numtext2">{{
                      panelInfo.todaySubscribeCnt
                    }}</span>
                    |
                    <span class="numtext2">{{
                      panelInfo.lastSubscribeCnt
                    }}</span>
                    单
                  </p>
                  <p
                    class="ptext"
                    v-if="
                      panelInfo.todaySubscribeAmount < 10000 ||
                      panelInfo.lastSubscribeAmount < 10000
                    "
                  >
                    今日 | 昨日：<span class="numtext2">{{
                      panelInfo.todaySubscribeAmount.toFixed(2)
                    }}</span>
                    |
                    <span class="numtext2">{{
                      panelInfo.lastSubscribeAmount.toFixed(2)
                    }}</span>
                    元
                  </p>

                  <p class="ptext" v-else>
                    今日 | 昨日：<span class="numtext2">{{
                      (panelInfo.todaySubscribeAmount / 10000).toFixed(2)
                    }}</span>
                    |
                    <span class="numtext2">{{
                      (panelInfo.lastSubscribeAmount / 10000).toFixed(2)
                    }}</span>
                    万元
                  </p>
                </div>
              </div>
            </div>
          </div>
        
          <div class="right-card">
            <h4 style="margin-top: 10px; color: #fff">商家提现汇总统计</h4>
            <div
              style="
                width: 100%;
                height: 120px;
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <div
                style="
                  width: 100%;
                  height: 100px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    background-color: rgb(55, 72, 124);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    src="../assets/images/txhz.png"
                    alt=""
                    style="width: 80%; height: 80%"
                  />
                </div>
                <div
                  style="
                    margin-left: 10px;
                    text-align: left;
                    color: #fff;
                    line-height: 25px;
                    height: 90upx;
                  "
                >
                  <p class="ptext" v-if="panelInfo.WithwardTotal < 10000">
                    提现总量：
                    <span class="numtext2" style="">
                      {{ panelInfo.WithwardTotalCnt}}
                    </span>
                    <span class="sptext">笔</span> 
                    |
                    <span class="numtext2">
                      {{
                        panelInfo.WithwardTotal
                      }}
                    </span>
                    <span class="sptext"> 元</span>
                  </p>
                  <p class="ptext" v-else>
                    提现总量：
                    <span class="numtext2" >
                      {{ panelInfo.WithwardTotalCnt }}
                    </span>
                      <span class="sptext">笔</span> 
                      |
                    <span class="numtext2">
                      {{
                        (panelInfo.WithwardTotal / 10000).toFixed(2)
                      }}
                    </span>
                    <span class="sptext">万元</span>
                  </p>
                  <p class="ptext" v-if="panelInfo.todayWithward < 10000">
                    今日提现：
                    <span class="numtext" >
                      {{ panelInfo.todayWithwardCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext" >
                      {{
                        panelInfo.todayWithward
                      }}
                    </span>
                    <span class="sptext"> 元</span>
                  </p>
                  <p class="ptext" v-else>
                    今日提现：
                    <span class="numtext">
                      {{ panelInfo.todayWithwardCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext" >
                      {{ (panelInfo.todayWithward / 10000).toFixed(2) }}
                      <span class="sptext"> 万元</span>
                    </span>
                  </p>
                  <p class="ptext" v-if="panelInfo.lastWithward < 10000">
                    等待处理：
                    <span class="numtext" >
                      {{ panelInfo.lastWithwardCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext" >
                      {{ panelInfo.lastWithward }} 
                      <span class="sptext"> 元</span>
                    </span>
                  </p>
                  <p class="ptext" v-else>
                    等待处理：
                    <span class="numtext">
                      {{ panelInfo.lastWithwardCnt }}
                    </span>
                      <span class="sptext">笔</span> |
                    <span class="numtext" >
                      {{ (panelInfo.lastWithward / 10000).toFixed(2) }}
                      <span class="sptext"> 万元</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      
        <div class="link">
          <div class="btnboss">
            <button
              v-for="day in days"
              :key="day"
              :class="isActive === day ? 'xuzhong2' : ''"
              @click="changeWeek(day)"
              class="xuzhong"
            >
              {{ day }}天
            </button>
          </div>
          <div id="eacharsBox" ref="boxone"></div>
        </div>
      </div>
      <div style="width: 18%">
        <div
          style="
            width: 100%;
            height: auto;
            background-color: rgb(45, 58, 100);
            margin-top: 20px;
            border-radius: 20px;
            padding: 10px 20px;
            box-sizing: border-box;
          "
        >
          <span style="color: #fff; font-size: 18px; font-weight: 400">会员等级信息</span>
          <div style="margin-top:10px">
            <!-- <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #fff;
              "
              v-for="(item, index) in userLevel" :key="index" 
            >
              <p class="ptext2" style="margin: 7px 0">{{ item.name }}</p>
              <p class="numtext" style="margin: 7px 0; font-size: 13px">
                {{ item.count }} 人
              </p>
            </div> -->
            
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #fff;
              ">
              <p class="ptext" style="margin: 7px 0">社区首领</p>
              <p class="numtext" style="margin: 7px 0; font-size: 13px">
                {{  panelInfo.userLeaderTotal }} 人
              </p>
            </div> 
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #fff;
              ">
              <p class="ptext" style="margin: 7px 0">省代理</p>
              <p class="numtext" style="margin: 7px 0; font-size: 13px">
                {{  panelInfo.userProvCnt }} 人
              </p>
            </div> 
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #fff;
              ">
              <p class="ptext" style="margin: 7px 0">市代理</p>
              <p class="numtext" style="margin: 7px 0; font-size: 13px">
                {{  panelInfo.userCityCnt }} 人
              </p>
            </div> 
             <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #fff;
              ">
              <p class="ptext" style="margin: 7px 0">区代理</p>
              <p class="numtext" style="margin: 7px 0; font-size: 13px">
                {{  panelInfo.userAreaCnt }} 人
              </p>
            </div> 

          </div>
        </div>
      </div>
    </div>
    
    <div
      style="
        width: 100%; display: flex; justify-content: space-between;
        margin: 0 auto;
        margin-top:25px;
      "
    >
      <div
        style="
          width: 22%;
          height: 200px;
          border-radius: 20px;
          padding: 10px 10px 0 10px;
          background-color: rgb(45, 58, 100);
        "
      >
        <h4 style="margin-top: 10px; color: #fff">商城营收统计</h4>
        <div
          style="
            width: 100%;
            height: 150px;
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div
            style="
              width: 100%;
              height: 100px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <div
              style="
                width: 80px;
                height: 80px;
                border-radius: 50px;
                background-color: rgb(55, 72, 124);
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/images/shnc.png"
                alt=""
                style="width: 80%; height: 80%"
              />
            </div>
            <div
              style="
                margin-left: 15px;
                text-align: left;
                color: #fff;
                line-height: 25px;
              "
            >
              <p class="ptext" v-if="panelInfo.ShopTotalTurnover < 10000">
                总营业额：<span class="numtext2"
                  >{{ panelInfo.ShopTotalTurnover.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                总营业额：<span class="numtext2"
                  >{{ (panelInfo.ShopTotalTurnover / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.todayShopTurnover < 10000">
                今日营业额：<span class="numtext2"
                  >{{ panelInfo.todayShopTurnover.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                今日营业额：<span class="numtext2"
                  >{{ (panelInfo.todayShopTurnover / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.lastShopTurnover < 10000">
                昨日营业额：<span class="numtext2"
                  >{{ panelInfo.lastShopTurnover.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                昨日营业额：<span class="numtext2"
                  >{{ (panelInfo.lastShopTurnover / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>

              <p class="ptext" v-if="panelInfo.todayppRL < 10000">
                今日让利：<span class="numtext2"
                  >{{ panelInfo.todayppRL.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                今日让利：<span class="numtext2"
                  >{{ (panelInfo.todayppRL / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.lastRL < 10000">
                昨日让利：<span class="numtext2"
                  >{{ panelInfo.lastRL.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                昨日让利：<span class="numtext2"
                  >{{ (panelInfo.lastRL / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
               <p class="ptext" v-if="panelInfo.todayScanPayAmt < 10000">
                今日扫码付：<span class="numtext2">{{ panelInfo.todayScanPayCnt }}</span>
                      <span class="sptext">笔</span> | <span class="numtext2">
                  {{panelInfo.todayScanPayAmt.toFixed(2) }} </span><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                今日扫码付：<span class="numtext2">{{ panelInfo.todayScanPayCnt }}</span>
                      <span class="sptext">笔</span> | 
                <span class="numtext2">{{ (panelInfo.todayScanPayAmt / 10000).toFixed(2) }} </span>
                <span class="sptext"> 万元</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          width: 22%;
          height: 200px;
          border-radius: 20px;
          padding: 10px 10px 0 10px;
          background-color: rgb(45, 58, 100);
        "
      >
        <h4 style="margin-top: 10px; color: #fff">共享区营收统计</h4>
        <div
          style="
            width: 100%;
            height: 120px;
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div
            style="
              width: 100%;
              height: 100px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <div
              style="
                width: 80px;
                height: 80px;
                border-radius: 50px;
                background-color: rgb(55, 72, 124);
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/images/pp.png"
                alt=""
                style="width: 80%; height: 80%"
              />
            </div>
            <div
              style="
                margin-left: 15px;
                text-align: left;
                color: #fff;
                line-height: 25px;
                height: 90upx;
              "
            >
              <p class="ptext" v-if="panelInfo.ppShopTotalTurnover < 10000">
                总营业额：<span class="numtext2">{{
                  panelInfo.ppShopTotalTurnover.toFixed(2)
                }}</span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                总营业额：<span class="numtext2">{{
                  (panelInfo.ppShopTotalTurnover / 10000).toFixed(2)
                }}</span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.todayppShopTurnover < 10000">
                今日营业额：<span class="numtext2">{{
                  panelInfo.todayppShopTurnover.toFixed(2)
                }}</span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                今日营业额：<span class="numtext2">{{
                  (panelInfo.todayppShopTurnover / 10000).toFixed(2)
                }}</span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.lastppShopTurnover < 10000">
                昨日营业额：<span class="numtext2">{{
                  panelInfo.lastppShopTurnover.toFixed(2)
                }}</span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                昨日营业额：<span class="numtext2">{{
                  (panelInfo.lastppShopTurnover / 10000).toFixed(2)
                }}</span
                ><span class="sptext"> 万元</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          width: 22%;
          height: 200px;
          border-radius: 20px;
          padding: 10px 10px 0 10px;
          background-color: rgb(45, 58, 100);
        "
      >
        <h4 style="margin-top: 10px; color: #fff">兑换区订单营收统计</h4>
        <div
          style="
            width: 100%;
            height: 120px;
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div
            style="
              width: 100%;
              height: 100px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <div
              style="
                width: 80px;
                height: 80px;
                border-radius: 50px;
                background-color: rgb(55, 72, 124);
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/images/fl.png"
                alt=""
                style="width: 80%; height: 80%"
              />
            </div>
            <div
              style="
                margin-left: 15px;
                text-align: left;
                color: #fff;
                line-height: 25px;
                height: 90upx;
              "
            >
              <p class="ptext" v-if="panelInfo.DHShopTotalTurnover < 10000">
                总营业额：<span class="numtext2">{{
                  panelInfo.DHShopTotalTurnover.toFixed(2)
                }}</span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                总营业额：<span class="numtext2">{{
                  (panelInfo.DHShopTotalTurnover / 10000).toFixed(2)
                }}</span>
                <span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.todayDHShopTurnover < 10000">
                今日营业额：<span class="numtext2">{{
                  panelInfo.todayDHShopTurnover.toFixed(2)
                }}</span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                今日营业额：<span class="numtext2">{{
                  (panelInfo.todayDHShopTurnover / 10000).toFixed(2)
                }}</span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.lastDHShopTurnover < 10000">
                昨日营业额：<span class="numtext2">{{
                  panelInfo.lastDHShopTurnover.toFixed(2)
                }}</span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                昨日营业额：<span class="numtext2">{{
                  (panelInfo.lastDHShopTurnover / 10000).toFixed(2)
                }}</span
                ><span class="sptext"> 万元</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          width: 22%;
          height: 200px;
          border-radius: 20px;
          padding: 10px 10px 0 10px;
          background-color: rgb(45, 58, 100);
        "
      >
        <h4 style="margin-top: 10px; color: #fff">活动区营收统计</h4>
        <div
          style="
            width: 100%;
            height: 120px;
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div
            style="
              width: 100%;
              height: 100px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <div
              style="
                width: 80px;
                height: 80px;
                border-radius: 50px;
                background-color: rgb(55, 72, 124);
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/images/shnc.png"
                alt=""
                style="width: 80%; height: 80%"
              />
            </div>
            <div
              style="
                margin-left: 15px;
                text-align: left;
                color: #fff;
                line-height: 25px;
                height: 90upx;
              "
            >
              <p class="ptext" v-if="panelInfo.AuctionTotalTurnover < 10000">
                总营业额：<span class="numtext2"
                  >{{ panelInfo.AuctionTotalTurnover.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                总营业额：<span class="numtext2"
                  >{{ (panelInfo.AuctionTotalTurnover / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.todayAuctionTurnover < 10000">
                今日营业额：<span class="numtext2"
                  >{{ panelInfo.todayAuctionTurnover.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                今日营业额：<span class="numtext2"
                  >{{ (panelInfo.todayAuctionTurnover / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
              <p class="ptext" v-if="panelInfo.lastAuctionTurnover < 10000">
                昨日营业额：<span class="numtext2"
                  >{{ panelInfo.lastAuctionTurnover.toFixed(2) }} </span
                ><span class="sptext"> 元</span>
              </p>
              <p class="ptext" v-else>
                昨日营业额：<span class="numtext2"
                  >{{ (panelInfo.lastAuctionTurnover / 10000).toFixed(2) }} </span
                ><span class="sptext"> 万元</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
var xArr = [];
var amountArr = [];
var amountArrDay = [];

export default {
  data() {
    return {
      chartInstance: null,
      data: {},
      userLevel: [],
      panelInfo: {},
      days: [7, 14, 30],
      // datahalfMonth: [],
      // dataMonth: [],
      isActive: 7,
      type: "groupbuyOrder",
      // dataweek: [],
    };
  },
  methods: {
    //echarts图
    initChart() {
      var boxs = document.getElementById("eacharsBox");
      var chart2 = this.$echarts.init(boxs);
      chart2.setOption({
        title: {
          text: "商城订单交易",
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["交易金额"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "2%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: amountArrDay,
          nameTextStyle: {
            color: "#fff",
          },
        },

        yAxis: {
          type: "value",
          min: "0"
          // max: amountArr + 10000,
        },

        series: [
          {
            name: "交易金额",
            type: "line",
            smooth: true,
            stack: "Total",
            data: amountArr,
            itemStyle: {
              normal: {
                color: "#1F824E", //改变折线点的颜色
                lineStyle: {
                  color: "skyblue", //改变折线颜色
                }
              }
            }
          }
        ],
      });
    },

    auctionSum() {
      amountArr = []
      amountArrDay=[]
      this.$api
        .homePageEchar({
          day: this.isActive
        })
        .then((res) => {
          if (res.state === "success") {
            // console.log('折线图数据--',res);
            res.data.map((item) => {
              amountArr.push(item.amount);
              amountArrDay.push(item.date.split('-')[1]+'/'+item.date.split('-')[2])
            });
            // console.log('时间--',amountArrDay)
            setTimeout(() => {
              this.initChart();
            }, 1000);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
    },
    changeWeek(day) {
      this.isActive = day;
      amountArr = [];
      amountArrDay=[];
      this.initChart();
      this.auctionSum();
    },
    getHomeDate() {
      this.$api
        .homePageVIP({})
        .then((res) => {
          if (res.state == "success") {
            this.userLevel = res.data.userList;
            // console.log("接口1--", res.data);
          }
        });
    },
    homePageStatisticsQuery() {
      this.$api.homePageStatisticsQuery({}).then((res) => {
        if (res.state == "success") {
          this.panelInfo = res.data;
          // console.log("接口2数据--", res.data);
        }
      });
    },
  },
  created() {
    this.auctionSum()
  },
  mounted() {
    this.getHomeDate();
    this.homePageStatisticsQuery();
  },
  updated() {},
};
</script>

<style scoped lang="less">
/deep/ .el-input__inner {
  color: black !important;
}

.ptext {
  color: #62709b;
}

.ptext2 {
  color: #62709b;
  font-size: 13px;
}

.numtext {
  color: #67a3d3;
  font-size: 18px;
  font-weight: 500;
}

.numtext2 {
  color: #67a3d3;
  font-size: 14px;
}

.reacd:hover {
  cursor: pointer;
}

.sptext {
  font-size: 13px;
  color: #62709b;
}
#eacharsBox {
  width: 100%;
  height: 80%;
  margin-top: 10px;
}
.link {
  width: 98%;
  height: 330px;
  background-color: rgb(45, 58, 100);
  // margin: 0 20px 0;
  border-radius: 20px;
  padding: 0 10px;
  padding-top: 10px;
  position: relative;

  .btnboss {
    text-align: right;
    margin-right: 50px;
    position: absolute;
    right: 50px;
    top: 20px;
    z-index: 1000;

    .xuzhong {
      width: 80px;
      height: 30px;
      border-radius: 20px;
      border: 1px solid #67a3d3;
      color: #67a3d3;
      margin-left: 5px;
      background: transparent;
    }

    .xuzhong2 {
      background: rgba(103, 163, 211, 0.2);
    }
  }
}

.one-row {
  width: 100%;
  height: 180px;
  border-radius: 20px;
  display: flex;
  justify-content: flex-start;
  margin: 20px 20px 5px;

  .left-card {
    width: 60%;
    border-radius: 20px;
    padding: 10px 10px 0 10px;
    background-color: rgb(45, 58, 100);
  }

  .right-card {
    width: 40%;
    border-radius: 20px;
    padding: 10px 0 0 10px;
    margin-left: 20px;
    background-color: rgb(45, 58, 100);
  }
}

.two-row {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid red;
  // margin: 5px 20px 0;


  
}
.card {
    width: 20%;
    height: 160px;
    border-radius: 20px;
    padding: 10px 10px 0 10px;
    background-color: rgb(45, 58, 100);
  }
</style>
